<template>
  <div class="w-full flex d2-keyword-layout pt-6" style="position:relative;">
    <loading :active="!this.showKeyWord"
            :can-cancel="true"
            :on-cancel="onCancel"
            :is-full-page="false"
            :color="'#fff'"
            :background-color="'#000'"
            :opacity="'0.8'"
            :loader=" dots">
    </loading>
    <div class="w-full downer-block d2-report-chart-card space-y-6" ref="tiktokwordcloudPanel" style="width:98%;">
      <main class="w-full flex flex-row flex-wrap justify-between items-center gap-2">
        <h5 class="d2-report-chart-title">{{lang['components']['Report']['KeyWord']['wordcloud_title']}}</h5>
        <div class="d2-kw-legend">
          <div class="d2-kw-legend-item">
            <div class="d2-kw-legend-dot" style="background: #FFB705;"></div> {{lang['components']['Report']['KeyWord']['wordcloud_status_a']}}
          </div>
          <div class="d2-kw-legend-item">
            <div class="d2-kw-legend-dot" style="background: #B9BDCD;"></div> {{lang['components']['Report']['KeyWord']['wordcloud_status_b']}}
          </div>
        </div>
      </main>
      <p class="d2-kw-info">{{lang['components']['Report']['KeyWord']['wordcloud_info']}}</p>
      <canvas width="500" height="400" class="wordcloud" ref="refChart"></canvas>
    </div>
    <div v-if="false" class="downer-block d2-report-chart-card space-y-6 ml-3" style="width: 36.3%;">
      <main class="panel-header">
        <h5 class="d2-report-chart-title">{{lang['components']['Report']['KeyWord']['key_word_list_title']}}</h5>
        <span class="actions-wording cursor-pointer" @click="keywordCampaign()">
          {{lang['components']['Report']['KeyWord']['key_word_list_use_create']}}
        </span>
      </main>
      <div class="report-list">
        <main>
          <div class="table-col-name">
            <h3 class="first-col">
              {{lang['components']['Report']['KeyWord']['key_word_list_field_a']}}
            </h3>
            <h3>
              {{lang['components']['Report']['KeyWord']['key_word_list_field_b']}}
            </h3>
          </div>
          <div
            class="table-col-value"
            v-for="(item, idx) in keywordsList"
            @click="handleSelectWord(item.key)"
            :key="idx"
            :class="selectWord.includes(item.key) ? 'select' : null"
          >
            <p
              class="first-col"
              :class="selectWord.includes(item.key) ? '' : null"
            >
              {{ item.key }}
            </p>
            <p :class="selectWord.includes(item.key) ? '' : null">
              {{ item.audience_size }}

            </p>
            <i v-if="selectWord.includes(item.key)" class="pi pi-check" style="margin-left: 30px;"></i>
          </div>
        </main>
      </div>
    </div>
  </div>
  <!-- <div id="myCanvasContainer" class="w-3/5">
    <canvas width="500" height="400" id="myCanvas" ref="canvas">
      <p>標題</p>
    </canvas>
  </div>
  <div id="tags">
    <ul>
      <li v-for="(tag, index) in members" :key="index">
        <a href="#" style="height: auto;font-size: 40px;color: #fff" onclick="return false" >
          {{tag.name}}
        </a>
      </li>
    </ul>
  </div> -->
  <!-- <div class="world-cloud-3d">
    <div class="world-cloud-canvas-wrapper">
      <canvas
        id="world-cloud-canvas"
        width="500"
        height="400"
        style="width: 100%; max-width: 500px"
      >
      </canvas>
    </div>
    <div style="display: none" id="weightTags"></div>
  </div> -->
</template>

<script>

import { ref, reactive, onMounted, onUpdated, onActivated, watch, watchEffect } from 'vue';
import WordCloud from 'wordcloud';
import Swal from 'sweetalert2/dist/sweetalert2.js'
import 'sweetalert2/dist/sweetalert2.min.css'
import Loading from 'vue3-loading-overlay';
import 'vue3-loading-overlay/dist/vue3-loading-overlay.css';
import "vue3-circle-progress/dist/circle-progress.css";
import axios from 'axios'
import Qs from 'qs'

export default {
  name: 'KeyWord',
  components: {
    Loading
  },
  props: {
    showKeyWord: {
      type: Boolean
    },
    adaccountIdSelect: {
      type: String
    },
    campaignIdSelect: {
      type: String
    },
    viewDatalist: {
      type: Object,
      default: () => []
    },
    lang: {
      type: Object
    },
  },
  setup(props) {
    const tiktokwordcloudPanel = ref();
    const refChart = ref();
    // const keywordsList = ref([
    //   { key: 'word', value: 10, isActive: true },
    //   { key: 'words', value: 8, isActive: true },
    //   { key: 'sprite', value: 7, isActive: true },
    //   { key: 'placed', value: 5, isActive: false },
    //   { key: 'layout', value: 4, isActive: true },
    //   { key: 'algorithm', value: 4, isActive: false },
    //   { key: 'area', value: 4, isActive: false },
    //   { key: 'without', value: 3, isActive: false },
    //   { key: 'step', value: 3, isActive: false },
    //   { key: 'bounding', value: 3, isActive: false },
    //   { key: 'retrieve', value: 3, isActive: true },
    //   { key: 'operation', value: 3, isActive: false },
    //   { key: 'collision', value: 3, isActive: true },
    //   { key: 'candidate', value: 3, isActive: true },
    //   { key: 'sad', value: 4, isActive: false },
    //   { key: 'hello', value: 2, isActive: false },
    //   { key: 'worlds', value: 3, isActive: true },
    //   { key: 'Apple', value: 5, isActive: true },
    //   { key: 'google', value: 5, isActive: true },
    // ]);
    const keywordsList = ref([]);
    // var keywordsList = [];

    const selectWord = ref([]);

    var check = 0;

    const handleSelectWord = (key) => {
      if (selectWord.value.includes(key)) {
        selectWord.value.splice(selectWord.value.indexOf(key), 1);
      } else {
        if (selectWord.value.length >= 5) {
          return;
        }
        selectWord.value.push(key);
      }
    };

    watchEffect(() => {
      // console.log('watchEffect b keywordsList');
      // console.log(keywordsList);
      keywordsList.value = props.viewDatalist;
      // console.log('watchEffect a keywordsList');
      // console.log(keywordsList);

      check = 0;//
    });

    // watchEffect(() => {
    //   console.log(keywordsList)
    // })

    // let myCanvas = ref(null)
    // let myContext = ref(null)
    // let manager = ref(null)
    // let size = reactive({
    //             w: tiktokwordcloudPanel.value.getBoundingClientRect().width * 0.9,
    //             h: tiktokwordcloudPanel.value.getBoundingClientRect().height * 0.8
    //         })

    // function draw() {
    //   myContext = myCanvas.value.getContext('2d')
    //   manager = new CanvasManager(myContext, size.w, size.h)
    //   manager.drawGrid(4, 4, 1, 'black')
    // }

    onUpdated(() => {
      // console.log('b check:'+check);

      if(check == 0){
        // try setTimeout？
        // var interval = setInterval( function () {
          // console.log('準備');
          if(keywordsList.value.length > 0 && check == 0){
            // console.log('in');
            const list = [];

            for (let idx = 0; idx < keywordsList.value.length; idx++) {
              list.push([
                keywordsList.value[idx].key,
                keywordsList.value[idx].value * 5
              ])
            }
            refChart.value.width = tiktokwordcloudPanel.value.getBoundingClientRect().width * 0.9;
            refChart.value.height = tiktokwordcloudPanel.value.getBoundingClientRect().height * 0.8;

            //console.log('#1 list');
            //console.log(list);
            WordCloud(refChart.value, {
              list: list,
              gridSize: 10,
              // weightFactor: function (size) {
              //   return size;
              // },
              weightFactor: (size) => {
                return size;
              },
              /* eslint-disable */
              // color: function (word, weight, fontSize, distance, theta) {
              //   const checkIsActive = keywordsList.value.filter(e => e.key === word);
              //   return checkIsActive[0]?.isActive ? '#FFB705' : '#B9BDCD';
              //   // (weight > 40) ? '#f02222' : '#000';
              // },
              color: (word, weight, fontSize, distance, theta) => {
                const checkIsActive = keywordsList.value.filter(e => e.key === word);
                return checkIsActive[0]?.isActive ? '#FFB705' : '#B9BDCD';
                // (weight > 40) ? '#f02222' : '#000';
              },
              classes: () => {
                return 'hover'
              },
              rotateRatio: 0,
              rotationSteps: 2,
              maskColor: '#f02222',
              hover: (item) => {
                // console.log(item)
              },
              click: (item) => {
                if (selectWord.value.includes(item[0])) {
                  selectWord.value.splice(selectWord.value.indexOf(item[0]), 1);
                } else {
                  if (selectWord.value.length >= 5) {
                    return;
                  }
                  selectWord.value.push(item[0]);
                }
              }
            });

            check = 1;

            // console.log('a check:'+check);
          } else {
            const list = [];
            refChart.value.width = tiktokwordcloudPanel.value.getBoundingClientRect().width * 0.9;
            refChart.value.height = tiktokwordcloudPanel.value.getBoundingClientRect().height * 0.8;

            //console.log('#2 list');
            //console.log(list);
            WordCloud(refChart.value, {
              list: list,
              gridSize: 10,
              // weightFactor: function (size) {
              //   return size;
              // },
              weightFactor: (size) => {
                return size;
              },
              /* eslint-disable */
              // color: function (word, weight, fontSize, distance, theta) {
              //   const checkIsActive = keywordsList.value.filter(e => e.key === word);
              //   return checkIsActive[0]?.isActive ? '#FFB705' : '#B9BDCD';
              //   // (weight > 40) ? '#f02222' : '#000';
              // },
              color: (word, weight, fontSize, distance, theta) => {
                // const checkIsActive = keywordsList.value.filter(e => e.key === word);
                // return checkIsActive[0]?.isActive ? '#FFB705' : '#B9BDCD';
                // (weight > 40) ? '#f02222' : '#000';
              },
              classes: () => {
                return 'hover'
              },
              rotateRatio: 0,
              rotationSteps: 2,
              maskColor: '#f02222',
              hover: (item) => {
                // console.log(item)
              },
              click: (item) => {
                // if (selectWord.value.includes(item[0])) {
                //   selectWord.value.splice(selectWord.value.indexOf(item[0]), 1);
                // } else {
                //   if (selectWord.value.length >= 5) {
                //     return;
                //   }
                //   selectWord.value.push(item[0]);
                // }
              }
            });
          }
        // }, 1000);
      }

    });

    // onUpdated(draw);

    return {
      selectWord,
      tiktokwordcloudPanel,
      refChart,
      keywordsList,
      handleSelectWord
    };
  },
  methods: {
    keywordCampaign(){
      // console.log('keywordCampaign');
      // console.log('code:'+this.$route.params.id);
      // console.log('adaccountIdSelect:'+this.adaccountIdSelect);
      // console.log('campaignIdSelect:'+this.campaignIdSelect);

      // console.log('keywordsList:'+this.keywordsList);
      let selectWord_length = this.selectWord.length

      if(selectWord_length > 0){
        axios
          .post('https://www.autoturn.net/api/keyword_with_campaign.php', Qs.stringify({
            s_code: this.$route.params.id,
            adaccount_id: this.adaccountIdSelect,
            campaign_id: this.campaignIdSelect,
            keywordsList: this.keywordsList,
            selectWord: this.selectWord
          }))
          .then((reResponse) => {
            if(reResponse.data.status == 'success'){
              //成功
              window.location.href = "https://private.autoturn.net/event-add/t/"+this.$route.params.id+"/"+this.adaccountIdSelect;
            } else {
              //失敗
              Swal.fire(
                    this.lang['components']['Report']['KeyWord']['methods']['keywordCampaign']['axios']['swal_title'],
                    reResponse.data.info,
                    reResponse.data.status
                  )
            }
            // console.log(reResponse.data);

            // this.keywordList = reResponse.data.return_data

            // console.log(this.keywordList);
          });
      } else {
        Swal.fire(
                    this.lang['components']['Report']['KeyWord']['methods']['keywordCampaign']['not_selectWord_length_swal_title'],
                    this.lang['components']['Report']['KeyWord']['methods']['keywordCampaign']['not_selectWord_length_swal_text'],
                    'warning'
                  )
      }
    }
  },
  // data() {
  //   return {
  //     refChartTest: [],
  //   }
  // },
  // watch: {
  //   viewDatalist(v) {
  //     const tiktokwordcloudPanel = ref();
  //     const refChart = ref();
  //     const selectWord = ref([]);
  //     const keywordsList = ref(v);

  //     console.log('viewDatalist');
  //     console.log(v);

  //     // console.log('b viewTypeSelect');
  //     // console.log(this.refChartTest);


  //     // console.log('a viewTypeSelect');
  //     // console.log(this.refChartTest);

  //     const list = [];
  //     for (let idx = 0; idx < keywordsList.value.length; idx++) {
  //       list.push([
  //         keywordsList.value[idx].key,
  //         keywordsList.value[idx].value * 10
  //       ])
  //     }
  //     refChart.value.width = tiktokwordcloudPanel.value.getBoundingClientRect().width * 0.9;
  //     refChart.value.height = tiktokwordcloudPanel.value.getBoundingClientRect().height * 0.8;

  //     console.log('list');
  //     console.log(list);
  //     WordCloud(refChart.value, {
  //       list: list,
  //       gridSize: 10,
  //       weightFactor: function (size) {
  //         return size;
  //       },
  //       /* eslint-disable */
  //       color: function (word, weight, fontSize, distance, theta) {
  //         const checkIsActive = keywordsList.value.filter(e => e.key === word);
  //         return checkIsActive[0]?.isActive ? '#FFB705' : '#B9BDCD';
  //         // (weight > 40) ? '#f02222' : '#000';
  //       },
  //       classes: () => {
  //         return 'hover'
  //       },
  //       rotateRatio: 0,
  //       rotationSteps: 2,
  //       maskColor: '#f02222',
  //       hover: (item) => {
  //         // console.log(item)
  //       },
  //       click: (item) => {
  //         if (selectWord.value.includes(item[0])) {
  //           selectWord.value.splice(selectWord.value.indexOf(item[0]), 1);
  //         } else {
  //           if (selectWord.value.length >= 5) {
  //             return;
  //           }
  //           selectWord.value.push(item[0]);
  //         }
  //       }
  //     });
  //   }
  // },
};
</script>
<style lang="scss" scoped>

h5 {
  font-family: PingFang HK;
  font-style: normal;
  font-weight: 600;
  font-size: 18px;
  line-height: 25px;
}

.downer-block {
  height: 42vw;
}

.wordcloud {
  width: auto;
  height: auto;
  cursor: pointer;
}

.actions-wording {
  font-family: PingFang HK;
  font-style: normal;
  font-weight: 600;
  font-size: 12px;
  line-height: 17px;
  text-align: right;
  text-decoration-line: underline;
  color: #72B6F4;
  cursor: pointer;

}

.panel-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}

.report-list {
  width: 100%;
  /* height: 28.1vw; */
  height: 90%;
  overflow: scroll;
  transition: 0.6s;
}

.table-padding {
  padding: 35px;
}

.table-col-name {
  display: flex;
  height: 24.15px;
  border-bottom: 1px solid #9B9B9B;

  .first-col {
    width: 300px;
  }

  h3 {
    font-family: PingFang HK;
    font-style: normal;
    font-weight: 600;
    font-size: 14px;
    line-height: 20px;
  }
}

.table-col-value {
  display: flex;
  height: 49.58px;
  padding-top: 7.26px;
  border-bottom: 1px solid #F7F7F7;
  transition: 0.3s;

  .first-col {
    width: 300px;
  }

  p {
    font-family: PingFang HK;
    font-style: normal;
    font-weight: normal;
    font-size: 12px;
    line-height: 17px;
    color: #7E7E7E;
  }
}

.table-col-value:hover {
  background: #e6ffff;
  cursor: pointer;
}

.select {
  background: #EDF4FC;
  color: #6298D7 !important;
}

.hover {
  cursor: pointer;
}

.medium {
  font-size: 20px;
  color: #a18cd1aa;
}
.small {
  font-size: 15px;
  color: #a18cd1aa;
}
</style>